import styled, { css } from "styled-components";

import { IconButton } from "@material-ui/core";

export const StyledIconBtn = styled(IconButton)`
  transition: 0.425s !important;

  ${(props) =>
    props.$bgColor &&
    css`
      background-color: ${(props) =>
        props.theme.palette[props.$bgColor]} !important;
    `}

  ${(props) =>
    props.$color &&
    css`
      color: ${(props) => props.theme.palette[props.$color]} !important;
    `}


  &:hover {
    ${(props) =>
      props.$hoverColor &&
      css`
        background-color: ${(props) =>
          props.theme.palette[props.$hoverColor]} !important;
      `}
  }
`;
